import {Injectable} from '@angular/core';
import {LorenColor} from '../../modules/loren-entity-form/components/loren-entity-form-field/constants/loren-color.constants';

@Injectable({
    providedIn: 'root'
})
export class LorenColorService {

    static getColor(index: number): string {
        if (index >= LorenColor.length) {
            // generate random color
            const n = (Math.random() * 0xfffff * 1000000).toString(16);
            return '#' + n.slice(0, 6);
        }

        return LorenColor[index].hexCode;
    }
}
